import React from 'react';
import { Box } from '@mui/material';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import DocuRuleContainer from '../../containers/companyinfomng/DocuRuleContainer';

// 2026-10-19 (ksm_frontend에서 포팅, 요구사항 5/07): ksm의 "회사정보설정" 화면은
// "회사 정보"(로고/인감 등) + "문서번호" 두 탭이지만, bito는 로고/인감 업로드 기능
// 자체가 없어(백엔드 API 미존재) 이번에는 문서번호 규칙 탭만 포팅한다.
// SYS_MENU_INF에는 이미 이 화면(MENU_ID=1907, link=companyinfomng)이 등록돼 있었다.
const CompanyInfoPage = () => {
  return (
    <Box>
      <BreadcrumbsContainer title="환경설정/회사 정보 입력" icon="common" />
      <Box sx={{ mx: 1 }}>
        <DocuRuleContainer />
      </Box>
    </Box>
  );
};

export default CompanyInfoPage;
